export type CaseRoomSearch = {
  event?: string;
  connected?: string;
};

export type CaseStorySearch = {
  t?: string;
};

/**
 * TanStack Router JSON-parser søkeparams (`?connected=1` → tallet 1).
 * Validering er derfor en funksjon, ikke Zod – Zod 4 sin Standard Schema
 * kaster og stopper hele saksrommet.
 */
function asSearchString(value: unknown): string | undefined {
  if (value === undefined || value === null || value === '') return undefined;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return undefined;
}

function pickSearchString(search: Record<string, unknown>, key: string): string | undefined {
  return asSearchString(search[key]);
}

export function validateCaseRoomSearch(search: Record<string, unknown>): CaseRoomSearch {
  const event = pickSearchString(search, 'event');
  const connected = pickSearchString(search, 'connected');
  return {
    ...(event === undefined ? {} : { event }),
    ...(connected === undefined ? {} : { connected }),
  };
}

export function validateCaseStorySearch(search: Record<string, unknown>): CaseStorySearch {
  const t = pickSearchString(search, 't');
  return t === undefined ? {} : { t };
}

export function isOAuthConnectedFlag(value: string | null | undefined): boolean {
  return value !== null && value !== undefined && value !== '';
}
